module.exports = __webpack_public_path__ + "img/fig14.41dbc735.jpg";